import {
  APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION,
  APPLICATION_ADD_PROCESS_DATACOLLECTION,
  APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP,
  APPLICATION_SELECT_DATACOLLECTION,
  APPLICATION_SELECT_DATACOLLECTIONGROUP,
  APPLICATION_SET_ACTIVE_PROPOSAL,
  APPLICATION_SET_ACTIVE_SESSION,
  APPLICATION_UNSELECT_DATACOLLECTION,
  APPLICATION_UNSELECT_DATACOLLECTIONGROUP,
  LOG_OUT,
} from '../constants/ActionTypes'

import remove from 'lodash/remove'

const initialState = {
  selectedDataCollectionGroups: [],
  selectedDataCollections: [],
  activeProposal: null,
  activeSession: null,
  processingDataCollectionGroup: null,
  processingDataCollection: null,
  processingAutoprocIntegration: null,
}

const application = (state = initialState, action) => {
  switch (action.type) {
    case APPLICATION_SET_ACTIVE_PROPOSAL: {
      state = {
        ...state,
        activeProposal: {
          name: action.payload.name,
          title: action.payload.title,
        },
      }
      break
    }
    case APPLICATION_SET_ACTIVE_SESSION: {
      state = {
        ...state,
        activeSession: {
          sessionId: action.payload.sessionId,
          title: action.payload.title,
        },
      }
      break
    }
    case APPLICATION_SELECT_DATACOLLECTIONGROUP: {
      let newState = []
      if (state.selectedDataCollectionGroups) {
        newState = state.selectedDataCollectionGroups.slice()
      }
      newState.push(action.payload.dataCollection)
      state = { ...state, selectedDataCollectionGroups: newState }
      break
    }

    case APPLICATION_UNSELECT_DATACOLLECTIONGROUP: {
      if (state.selectedDataCollectionGroups) {
        remove(state.selectedDataCollectionGroups, function (currentObject) {
          return (
            currentObject.raw.DataCollectionGroup_dataCollectionGroupId ===
            action.payload.dataCollection.raw.DataCollectionGroup_dataCollectionGroupId
          )
        })
      }
      state = { ...state, selectedDataCollectionGroups: state.selectedDataCollectionGroups }
      break
    }

    case APPLICATION_SELECT_DATACOLLECTION: {
      let newState = []
      if (state.selectedDataCollections) {
        newState = state.selectedDataCollections.slice()
      }
      newState.push(action.payload.dataCollection)

      state = { ...state, selectedDataCollections: newState }
      break
    }

    case APPLICATION_UNSELECT_DATACOLLECTION: {
      if (state.selectedDataCollections) {
        remove(state.selectedDataCollections, function (currentObject) {
          return currentObject.dataCollectionId === action.payload.dataCollection.dataCollectionId
        })
      }
      state = { ...state, selectedDataCollections: state.selectedDataCollections }
      break
    }

    case APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP: {
      let newState = []

      if (state.processingDataCollectionGroup) {
        newState = state.processingDataCollectionGroup.slice()
      }
      newState.push(action.payload.dataCollectiongroup)
      state = { ...state, processingDataCollectionGroup: newState }
      break
    }

    case APPLICATION_ADD_PROCESS_DATACOLLECTION: {
      let newState = []
      if (state.processingDataCollection) {
        newState = state.processingDataCollection.slice()
      }
      newState.push(action.payload.dataCollection)
      state = { ...state, processingDataCollection: newState }
      break
    }

    case APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION: {
      let newState = []
      if (state.processingAutoprocIntegration) {
        newState = state.processingAutoprocIntegration.slice()
      }
      newState.push(action.payload.processingAutoprocIntegration)
      state = { ...state, processingAutoprocIntegration: newState }
      break
    }

    case LOG_OUT: {
      state = {}
      break
    }

    default:
      break
  }
  return state
}

export default application
